<template>
  <div>
    <Header/>
    <Navigationzj/>
    <div class="hxq_subpage">
      <div>
        <div class="hxq_spxx" style="padding: 0;">
          <div class="hxq_spxx1">
            <!--面包屑导航-->
            <div class="hxq_yzjk_mbx" v-if="goodsDetail.categorys">
              <router-link :to="{path:'/'}" class="allResult">首页<span>></span></router-link>
              <router-link :to="{path:'/Classify',query:{grand_id: goodsDetail.categorys[0]['id']}}" class="allResult">
                 {{goodsDetail.categorys[0].title}}
                <span class="newspan">></span>
              </router-link>
              <router-link :to="{path:'/Classify',query:{parent_id: goodsDetail.categorys[1].id}}" class="allResult">
                {{goodsDetail.categorys[1].title}}
                <span class="newspan">></span>
              </router-link>
              <router-link :to="{path:'/Goods',query:{cid: goodsDetail.categorys[2].id}}" class="allResult">
                {{goodsDetail.categorys[2].title}}
              </router-link>
            </div>
            <!--面包屑导航-->
            <div class="clearfix" v-loading="qyloading">
              <div class="hxq_spxx1_lt">
                <div class="hxq_spxx1_lt_b">
                  <div class="tempWrap" style="overflow:hidden; position:relative; width:418px">
                    <ul class="hxq_spxx1_lt_b_ul" style="left: 0px; position: relative; overflow: hidden; padding: 0px; margin: 0px;">
                      <!--大图-->
                      <!-- <li v-for="(img,index) in goodsDetail.imgpath" :key="index" style="float: left; width: 418px;"> -->
                        <!-- <img class="jqzoom" :src="ImgUrl" width="418" height="418" style="cursor: crosshair;"> -->
                        <div class="pic-box">
                          <pic-zoom :url="ImgUrl" :scale="2"></pic-zoom>
                        </div>
                      <!-- </li> -->
                    </ul>
                  </div>
                </div>
                <div class="hxq_spxx1_lt_h">
                  <div class="tempWrap" style="overflow:hidden; position:relative; width:410px">
                    <ul class="hxq_spxx1_lt_h_ul" style="width: 410px; left: 0px; position: relative; overflow: hidden; padding: 0px; margin: 0px;">
                    <!--小图-->
                      <li v-for="(img,index) in goodsDetail.imgpath" :key="index" style="float: left; width: 67px;border: 1px solid #ccc;">
                        <img :src="img" width="67" height="67" @mouseenter="getIndex(index)">
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="hxq_spxx_fx_box">
                  <!-- <div class="bdsharebuttonbox bdshare-button-style0-16" id="bdfx">
                    <a href="#" class="bds_more" data-cmd="more">分享</a>
                  </div> -->
                  <!-- <share :config="config" style="display: inline-flex;float: left;"></share> -->
                  <div class="bdsharebuttonbox bdshare-button-style0-16" id="bdfx">
                    销量：<count-to :start-val="0" :end-val="parseInt(goodsDetail.sales)" :duration="2600" class="card-panel-num"/>
                  </div>
                  <div class="hxq_spxx_fx hs-collect" style="margin-top:5px;">
                    <i v-if="goodsDetail.isCollect" class="el-icon-star-on" style="color:#ff7324;font-size:18px;line-height:18px;display:flex;cursor:pointer;" @click="delOrAddCollect(goodsDetail.id)"><em style="font-size:14px;">已收藏</em></i>
                    <i v-else class="el-icon-star-off" style="color:#ff7324;font-size:18px;line-height:18px;display:flex;cursor:pointer;" @click="delOrAddCollect(goodsDetail.id)"><em style="font-size:14px;">收藏</em></i>
                  </div>
                </div>
              </div>
              <div class="hxq_spxx1_rt">
                <em class="hxq_spxx1_rt_mc_h">{{goodsDetail.full_title}}</em>
                <div v-show="showFlashsale" v-if="goodsDetail.is_flash == 2" class="hxq_spxx1_rt_mc">
                  <div class="hxq_spxx1_rt_jg_sk">
                    <div class="activity-timedown">
                      距离结束还剩
                      <span class="timedown m-timedown">
                        <span class="item">
                          <i class="n s">{{ day }}</i>
                          <i class="u">天</i>
                        </span>
                        <span class="item">
                          <i class="n">{{ hou }}</i>
                          <i class="u s z">时</i>
                        </span>
                        <span class="item">
                          <i class="n">{{ min }}</i>
                          <i class="u s z">分</i>
                        </span>
                        <span class="item">
                          <i class="n">{{ sec }}</i>
                          <i class="u z">秒</i>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="hxq_spxx1_rt_mc">
                  <div class="hxq_spxx1_rt_jg">
                    <template v-if="goodsDetail.serial_number">
                      <em style="width:70px;line-height:47px;">协议价：</em>
                      <span>
                        <em>￥</em>{{goodsDetail.tax_price}}
                      </span>
                    </template>
                    <template v-else>
                      <!-- <em style="width:60px;line-height:45px;" v-if="goodsDetail.tax_price && goodsDetail.tax_price > 0">含税价:</em> -->
                      <span v-if="goodsDetail.tax_price && goodsDetail.tax_price > 0"><em>￥</em>{{goodsDetail.tax_price}}</span>
                      <span v-else><em>询价</em></span>
                      <!-- <div v-if="goodsDetail.sale_price && goodsDetail.sale_price > 0" class="yj" style="color:#919191;margin-left:20px;display: inline-block;font-size: 12px;">不含税价：￥{{goodsDetail.sale_price}}</div> -->
                    </template>
                  </div>
                </div>
                <div style="height: 10px;"></div>
                <em style="font-size:12px;color:#fe2c2c;">注意：因市场行为原因，部分产品的货期和价格不稳定，请以咨询客服为准，敬请谅解~</em>
                <div style="height: 10px;"></div>
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh ">
                  <em v-if="goodsDetail.plant_sku && current_user.id">物料代码:</em>
                  <em v-else>志鹏货号:</em>
                  <div>{{goodsDetail.plant_sku || goodsDetail.sku}}</div>
                </div>
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh">
                  <em>品&emsp;&emsp;牌:</em>
                  <el-tooltip class="item" effect="dark" :content="cont" placement="top-start" v-if="goodsDetail.brand_id == 270">
                    <!-- <el-button>{{goodsDetail.brand_title}}</el-button> -->
                    <div>{{goodsDetail.brand_title}}</div>
                  </el-tooltip>
                  <div v-else>{{goodsDetail.brand_title}}</div>
                </div>
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh" v-if="goodsDetail.specification" :style="goodsDetail.specification.length > 15 ?'width:100%':'width:50%'">
                  <em>规&emsp;&emsp;格:</em>
                  <div>{{goodsDetail.specification}}</div>
                </div>
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh">
                  <em>起&ensp;批&ensp;量:</em>
                  <div>≥ {{goodsDetail.limits}}</div>
                </div>
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh">
                  <em>单&emsp;&emsp;位:</em>
                  <div>{{goodsDetail.units}}</div>
                </div>
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh">
                  <em>预计出货:</em>
                  <div v-if="goodsDetail.delivery_time">{{goodsDetail.delivery_time}}个工作日</div>
                  <div v-else>当天</div>
                </div>
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh" v-if="goodsDetail.model_number">
                  <em>型&emsp;&emsp;号:</em>
                  <div style="width:200px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;" :title="goodsDetail.model_number">{{goodsDetail.model_number}}</div>
                </div>
                <!-- <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh">
                  <em>数量</em>
                  <p><el-input-number size="small" v-model="goodsDetail.number" :min="goodsDetail.limits"></el-input-number></p>
                </div> -->
                <div class="mySpecParam" style="padding-top:10px; border-bottom:1px dotted #ccc;">
                  <div v-for="(item,index) in goodsDetail.specParamList" :key="index" style="display:inline-block;">
                    <em>{{item.param_name}}：</em>
                    <div>{{item.option_value}}</div>
                  </div>
                </div>
                <leave-message ref="leavemsg" :msgjson="goodsDetail.leaveMessage" v-if="goodsDetail.leaveMessage" v-model="LeaveMessage"></leave-message>
                <!-- <div class="mySpecParam">
                  <template v-for="(item,index) in goodsDetail.leaveMessage">
                    <em :key="index">{{item.msgTitle}}：</em>
                    <el-input v-model="item.value" :key="index" size="small" style="width:160px;" placeholder="请输入内容"></el-input>
                  </template>
                </div> -->
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh" style="width:100%;line-height: 30px;" @mouseleave="mouseLeave">
                  <em>配&ensp;送&ensp;至:</em>
                  <div class="hxq_delivery" @mouseover="mouseOver">
                    <i class="el-icon-location"></i>{{address.province}}{{address.city}}{{address.area}} <i class="el-icon-arrow-down"></i>
                  </div>
                  <div v-show="distpickershow" class="hxq_distpicker">
                    <VDistpicker
                      type='mobile'
                      :province="address.province"
                      :hide-area="hideArea"
                      @province="onChangeProvince"
                      @city="onChangeCity"
                      @area="onChangeArea"
                      style="width:500px;height:34px;box-shadow: 0 1px 2px 1px #ddd;"
                      address-header="address-headers"
                    ></VDistpicker>
                  </div>
                </div>
                <div style="height: 30px;color:#aea8a8;font-size: 12px;line-height: 30px;display: inline-block;">注：目前只支持配送到内蒙古呼和浩特、包头、鄂尔多斯地区</div>
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh" style="width:100%;">
                  <!-- <em>客服电话:</em>
                  <div>400-040-7890</div> -->
                  <p class="kfdh">
                    <span style="letter-spacing: 0px;">
                      <i class="el-icon-phone-outline"></i> 400-040-7890 &nbsp;&nbsp;
                    </span>
                    <span>
                      <router-link :to="{path:'/Service'}" title="在线客服" target="_blank">
                        <i class="el-icon-service"></i> 在线客服
                      </router-link>
                    </span>
                  </p>
                </div>
                <div class="hxq_spxx1_rt_xx hxq_spxx1_rt_hh" style="width:100%;">
                  <em style="line-height:30px;">支付方式:</em>
                  <div style="color: #919191;">
                    <span><img src="../../assets/images/inco/wethac.png" width="20px" style="vertical-align: middle;"/>微信支付</span>&ensp;
                    <span><img src="../../assets/images/inco/zhifub.png" width="20px" style="vertical-align: middle;"/>支付宝支付</span>&ensp;
                    <span><img src="../../assets/images/inco/bank.png" width="20px" style="vertical-align: middle;"/> 银行转账</span>&ensp;
                  </div>
                </div>
                <div style="height: 30px;color:#aea8a8;font-size: 12px;line-height: 30px;display: inline-block;">注：图片仅供参考，请以实物为准，如有侵权，请联系管理员下架</div>
                <div class="hxq_spxx1_rt_btn" style="display: inline-block;">
                  <el-input-number size="medium" v-model="goodsDetail.number" :min="goodsDetail.limits"></el-input-number>
                  <a href="javascript: void(0);" class="ljgm" @click="buyItNow(goodsDetail.id)">立即购买</a>
                  <a href="javascript: void(0);" class="join_cart" @click="addCart(goodsDetail.id)">加入购物车</a>
                </div>
              </div>
              <div class="pp_logo" style="float: right;">
                <router-link :to="{path:'/Ppxq?bid='+goodsDetail.brand_id}" :title="goodsDetail.brand_title" target="_blank">
                  <img v-real-img="goodsDetail.img" src="../../assets/images/zwtp.jpg" width="200" height="103" style="border:1px solid #ededed;"/>
                </router-link>
                <div class="kuazp">
                  <div class="kuazp_cont" v-if="goodsDetail.brand_cont">
                    {{goodsDetail.brand_cont}}
                  </div>
                  <div class="kuazp_tit" v-else>
                    {{goodsDetail.brand_title}}
                  </div>
                  <div :class="goodsDetail.videopath?'':'kuazp_image'">
                    <video v-if="goodsDetail.videopath" muted controls autoplay="autoplay" loop :src="goodsDetail.videopath" width="199"></video>
                    <!-- <img v-else src="../../assets/images/zpsmlogo00.png" alt="" width="199"> -->
                    <div v-else class="other clearfix">
                      <p class="title">服务说明</p>
                      <ul class="service-des">
                        <li>· 由志鹏供应链及授权供应商发货 并提供售后服务</li>
                        <li>· 因库存实时变化，具体发货时间 以实际发货为准</li>
                      </ul>
                      <!-- <p class="title">售前说明</p>
                      <p class="sale-before-des">
                        <span style="letter-spacing: 0px;">
                          <i class="el-icon-phone-outline"></i> 400-040-7890 &nbsp;&nbsp;
                        </span>
                        <span>
                          <router-link :to="{path:'/Service'}" title="在线客服" target="_blank">
                            <i class="el-icon-service"></i> 在线客服
                          </router-link>
                        </span>
                      </p> -->
                      <div style="display:flex;">
                        <div class="service_value">
                          <div class="img_label">
                            <span class="icon_value">正</span>
                            <span class="text_value">正品保障</span>
                          </div>
                          <div class="img_label">
                            <span class="icon_value">票</span>
                            <span class="text_value">增票开具</span>
                          </div>
                          <div class="img_label">
                            <span class="icon_value">售</span>
                            <span class="text_value">售后服务</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="other_xh_t" v-if="goodsDetail.correlation && goodsDetail.correlation.length > 0">
            同类其他产品
          </div>
          <div v-if="goodsDetail.correlation && goodsDetail.correlation.length > 0" class="other_xh_t" style="font-size: 12px;border-top: none;border-bottom: none;background: none;">
            {{goodsDetail.brand_title}}品牌“<b style="color:#ff7324;">{{goodsDetail.title}}</b>”的同类其他产品
          </div>
          <div v-if="goodsDetail.correlation && goodsDetail.correlation.length > 0" class='other_xh hg sg' style="overflow-y: auto;overflow-x: auto;height:300px;border: 1px solid #f1eeee;">
            <div style="position: relative;">
              <div class="fllbsmall_con_tit clearfix" style="background: #fff;border-right: 1px solid #f1eeee;">
                <div class="w316"><span>商品信息</span></div>
                <div v-if="goodsDetail.specParamList && goodsDetail.specParamList.length <= 6" style="width: 505px;float: left;border-right:none;">
                  <div v-for="(item,index) in goodsDetail.specParamList" :key="index" :style="'width: ' + 100 / goodsDetail.specParamList.length + '%'">
                    {{item.param_name}}
                  </div>
                </div>
                <template v-else>
                  <div v-for="(item,index) in goodsDetail.specParamList" :key="index">
                    {{item.param_name}}
                  </div>
                </template>
                <div class="w133" style="width:93px;">志鹏价</div>
                <div class="w140" style="width:135px;">预计出货日</div>
                <div class="w145" style="width: 130px;border-right: none;">购买数量</div>
              </div>
              <div class="fllbsmall_con_bottom" style="height:auto;min-height: 0px;">
                <ul>
                  <li v-for="(cor,index) in goodsDetail.correlation" :key="index" class='clearfix' style="padding: 3px 0;border-right: 1px solid #f1eeee;">
                    <div class="w316 fllbsmall_con_bottom_1 clearfix">
                      <router-link class="fllbsmall_con_bottom_1l"
                        :to="{path:'/GoodsDetail',query:{id:cor.id}}"
                        target="_blank" :title="cor.title"
                        style="margin-right: 10px;">
                        <img v-real-img="cor.imgpath" src="../../assets/images/zwtp.jpg" :alt="cor.title" width="76" height="76">
                      </router-link>
                      <div class="fllbsmall_con_bottom_1r">
                        <h3>
                          <router-link class="newtitles" :to="{path:'/GoodsDetail',query:{id:cor.id}}" target="_blank" :title="cor.title">{{cor.title}}</router-link>
                          </h3>
                        <span>订货号：{{cor.plant_sku || cor.sku}}</span>
                      </div>
                    </div>
                    <div v-if="cor.specParamList && cor.specParamList.length <= 6" style="width: 505px;float: left;border-right:none;">
                      <div class="m33" v-for="(item,index) in cor.specParamList" :key="index" :style="'width:' + 100 / cor.specParamList.length + '%'">
                        {{item.option_value}}
                      </div>
                    </div>
                    <div class="w133 red m33" v-if="cor.tax_price" style="width:93px;font-weight:bold;">￥{{cor.tax_price}}</div>
                    <div class="w133 red m33" v-else style="width:93px;font-weight:bold;">询价</div>
                    <div class="w140 list_surekc" style="width:135px;margin-top:20px;">
                      <span v-if="cor.delivery_time">{{cor.delivery_time}}个工作日出货</span>
                      <span v-else>当日出货</span>
                    </div>
                    <div class="w145 list_sureinput" style="width: 130px;margin-top:23px;">
                      <el-input-number size="small" v-model="cor.number" :min="cor.limits" @change="calculate(cor)"></el-input-number>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="spxx_chakan clearfix" v-if="goodsDetail.correlation && goodsDetail.correlation.length > 0">
            <router-link class="spxx_chakan_l" target="_blank" :to="{path:'/Goods',query:{cid:goodsDetail.category_id}}">
              查看同分类下所有产品(共{{goodsDetail.correlation.length}}件)>>
            </router-link>
            <div class="spxx_chakan_r" >
              共选择了<em class="red" zp_kind>{{goodsNum}}</em>种&emsp;共<em class="red" zp_num>{{totalNumber}}</em>件商品&emsp;总价：<em class="red" zp_price>¥{{totalAmount}}</em>
              <div class="hxq_ppsp_ul_join_r"><a href="javascript:void(0);" @click="batchAddCart">加入购物车</a></div>
            </div>
          </div> -->
          <!-- 新增产品选项 -->
          <div v-if="(goodsDetail.correlation && goodsDetail.correlation.length > 0) || sameparameterdata.length > 0" class="other-goods-wrap">
            <div class="tabs-box">
              <span :class="{select_tab:showinfo === 1}" @click="showproductinfo(1)">其他所有型号</span>
              <span v-if="sameparameterdata.length > 0" :class="{select_tab:showinfo === 2}" @click="showproductinfo(2)">同参数型号</span>
            </div>
            <!-- 其他所有型号 -->
            <div v-if="showinfo === 1" class="goods-select-box clearfix">
              <div class="side-select-wrap goods-select-side">
                <div class="left-header">
                  <em style='color:#fff'>...</em>
                  <span>产品选项</span>
                  <a class="reset-btn" @click="clearcheckbox()">清空筛选</a>
                </div>
                <ul style="overflow-y: auto;min-height: 350px;max-height: 536px;">
                  <li v-for="(item,index) in SameSpeci" :key="index" class="attr-item attr-item-iw">
                    <div class="item-header">{{ item.param_name }}<i :class="item.open?'up-arrow':''" @click="changeopen(item)"></i></div>
                    <div :id="'gotop'+index" class="attr-option-container checkbox clearfix max-container" :style="[{display:item.open?'block':'none'},{maxHeight:item.childopen?'100px':'240px'},{overflowY:item.childopen?'hidden':'auto'}]">
                      <ul class="checkbox-grop-wrap clearfix">
                        <li v-for="(items,indexs) in item.child" :key="indexs" :style="items.option_value.length > 8 ?'width:98%':'width:50%'">
                          <el-checkbox class="checkbox-input" v-model="items.checked" @change="checkedFn(items)">{{ items.option_value }}</el-checkbox>
                        </li>
                      </ul>
                    </div>
                    <div v-if="item.child.length > 6" class="more_option" :style="[{display:item.open?'block':'none'}]" @click="changeopenmore(item,index)"><span>{{ item.childopen?'查看更多':'收起' }}</span><i :class="item.childopen?'':'up-arrow'"></i></div>
                  </li>
                </ul>
              </div>
              <div class="goods-select-list">
                <div class="search-box" v-if="false">
                  <label>
                    <i class="bg-search-icon"></i>
                    <input v-model="screensearch" type="text" placeholder="请输入产品名称 订货号">
                  </label>
                  <button @click="screensearchs()">查询</button>
                </div>
                <div class="list-detail-wrap">
                  <ul class="list-item-header clearfix">
                    <li class="tw1">商品信息</li>
                    <li class="tw2">发货日</li>
                    <li class="tw3">单位</li>
                    <li class="tw4">含税单价（元）</li>
                    <li class="tw5">订购数量</li>
                    <li class="tw6">操作</li>
                  </ul>
                  <ul v-if="goodsDetail.correlation && goodsDetail.correlation.length > 0" :style="autoheight" v-loading="loading">
                    <li class="goods-list clearfix" v-for="(cor,index) in goodsDetail.correlation" :key="index">
                      <div class="goods-info tw1">
                        <router-link class="img-wrap" :to="{path:'/GoodsDetail',query:{id:cor.id}}" target="_blank" :title="cor.full_title">
                          <img v-real-img="cor.imgpath" src="../../assets/images/zwtp.jpg" :alt="cor.full_title">
                        </router-link>
                        <div class="goods-name">
                          <div class="goods-tagcont clearfix"></div>
                          <router-link class="name" :to="{path:'/GoodsDetail',query:{id:cor.id}}" target="_blank" :title="cor.full_title">{{cor.full_title}}</router-link>
                          <div class="clearfix sku-number">
                            <span>订货号：{{cor.plant_sku || cor.sku}}</span>
                            <!-- <br>
                            <span title="APFNCHD42100">制造商型号：APFNCHD42100</span> -->
                          </div>
                        </div>
                      </div>
                      <div class="tw2 deliver-leadTime">
                        <i v-if="cor.delivery_time" class="deliver h48">{{cor.delivery_time}}个工作日出货</i>
                        <i v-else class="deliver h48">次日发货</i>
                      </div>
                      <div class="tw3 real-unit">{{cor.units}}</div>
                      <div class="tw4 goods-price">
                        <span class="sell-price" v-if="cor.tax_price">￥{{cor.tax_price}}</span>
                        <span class="sell-price" v-else>询价</span>
                      </div>
                      <div class="tw5">
                        <div class="clearfix add-shop-cart size-normal">
                          <el-input-number size="small" v-model="cor.number" :min="cor.limits" @change="calculate(cor)"></el-input-number>
                        </div>
                      </div>
                      <div class="tw6 btn-wrap">
                        <button class="add-cart-btn" @click="batchAddCart">
                          <i class="el-icon-shopping-cart-2"></i>
                          <span>加入购物车</span>
                        </button>
                        <!-- <br>
                        <button class="compare-btn">对比</button>
                        <br> -->
                      </div>
                    </li>
                  </ul>
                  <div class="cght_cnxhtiwtjsp" v-if="goodsDetail.correlation && goodsDetail.correlation.length === 0" style="padding-top:230px;">
                    <div>
                      <em class="myemptydata">暂无数据</em>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 其他所有型号 -->
            <!-- 同参数型号 -->
            <div v-if="showinfo === 2" class="goods-select-box clearfix">
              <div class="list-detail-wraps">
                <ul class="list-item-header clearfix">
                  <li class="tw1">商品信息</li>
                  <li class="tw2">参数</li>
                  <li class="tw3">发货日</li>
                  <li class="tw4">单位</li>
                  <li class="tw5">含税单价（元）</li>
                  <li class="tw6">订购数量</li>
                  <li class="tw7">操作</li>
                </ul>
                <ul v-if="sameparameterdata && sameparameterdata.length > 0" class="list-item-side" v-loading="loading">
                  <li class="goods-list clearfix" v-for="(cor,index) in sameparameterdata" :key="index">
                    <div class="goods-info tw1">
                      <router-link class="img-wrap" :to="{path:'/GoodsDetail',query:{id:cor.id}}" target="_blank" :title="cor.full_title">
                        <img v-real-img="cor.imgpath" src="../../assets/images/zwtp.jpg" :alt="cor.full_title">
                      </router-link>
                      <div class="goods-name">
                        <div class="goods-tagcont clearfix"></div>
                        <router-link class="name" :to="{path:'/GoodsDetail',query:{id:cor.id}}" target="_blank" :title="cor.full_title">{{cor.full_title}}</router-link>
                        <div class="clearfix sku-number">
                          <span>订货号：{{cor.plant_sku || cor.sku}}</span>
                          <!-- <br>
                          <span title="APFNCHD42100">制造商型号：APFNCHD42100</span> -->
                        </div>
                      </div>
                    </div>
                    <div class="tw2 goods-parameter">
                      <div class="clearfix sku-number">
                        <span v-for="(item,indexs) in cor.specParamList" :key="indexs">{{item.param_name}}：{{item.option_value}}</span>
                      </div>
                    </div>
                    <div class="tw3 deliver-leadTime">
                      <i v-if="cor.delivery_time" class="deliver h48">{{cor.delivery_time}}个工作日出货</i>
                      <i v-else class="deliver h48">次日发货</i>
                    </div>
                    <div class="tw4 real-unit">{{cor.units}}</div>
                    <div class="tw5 goods-price">
                      <span class="sell-price" v-if="cor.tax_price">￥{{cor.tax_price}}</span>
                      <span class="sell-price" v-else>询价</span>
                    </div>
                    <div class="tw6">
                      <div class="clearfix add-shop-cart size-normal">
                        <el-input-number size="small" v-model="cor.number" :min="cor.limits" @change="calculate(cor)"></el-input-number>
                      </div>
                    </div>
                    <div class="tw7 btn-wrap">
                      <button class="add-cart-btn" @click="batchAddCart">
                        <i class="el-icon-shopping-cart-2"></i>
                        <span>加入购物车</span>
                      </button>
                      <!-- <br>
                      <button class="compare-btn">对比</button>
                      <br> -->
                    </div>
                  </li>
                </ul>
                <div class="cght_cnxhtiwtjsp" v-if="goodsDetail.correlation && goodsDetail.correlation.length === 0" style="padding-top:230px;">
                  <div>
                    <em class="myemptydata">暂无数据</em>
                  </div>
                </div>
              </div>
            </div>
            <!-- 同参数型号 -->
          </div>
          <!-- 新增产品选项 -->
          <div class="hxq_spxx2">
            <div class="hxq_spxx2_lt">
              <div class="hxq_spxx2_lt_h">相似推荐</div>
              <div class="hxq_spxx2_lt_b">
                <ul class="hxq_spxx2_lt_b_ul">
                  <li v-for="(item,index) in goodsDetail.recommend" :key="index">
                    <router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.full_title">
                      <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" alt="" width="181" height="181">
                    </router-link>
                    <h3>
                      <router-link :to="{path:'/GoodsDetail',query:{id:item.id}}" target="_blank" :title="item.full_title">
                        {{ item.full_title }}
                      </router-link>
                    </h3>
                    <span v-if="item.tax_price">￥{{item.tax_price}}</span>
                    <span v-else>询价</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="hxq_spxx2_rt">
                <div class="hxq_spxx2_rt_h">
                  <em>产品详细</em>
                </div>
                <div class="hxq_spxx2_rt_b">
                  <div class="hxq_spxx2_rt_xx">
                    <div class="clearfix">
                      <div class="hxq_spxx2_rt_content" style="clear:both;" v-html="goodsDetail.content"></div>
                    </div>
                  </div>
                  <!-- <img src="../../assets/images/notice.png" alt="购物须知" width="100%" style="border: 1px solid #ededed;"> -->
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
// 分享
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css'
import '../../../node_modules/social-share.js/dist/js/social-share.min.js'
import api from '@/api/goods'
import flashsale from '@/api/flashsale'
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import { mapGetters } from 'vuex'
// import Bottom from '@/components/Member/Bottom'
import Footer from '@/components/Footer'
import LeaveMessage from '@/components/LeaveMessage'
import PicZoom from 'vue-piczoom'
import CountTo from 'vue-count-to'
import VDistpicker from 'v-distpicker'
import DISTRICTS from '../../../node_modules/v-distpicker/src/districts.js'

export default {
  name: 'GoodsDetail',
  components: {
    Header,
    Navigationzj,
    Footer,
    LeaveMessage,
    Share,
    PicZoom,
    CountTo,
    VDistpicker,
    DISTRICTS
  },
  inject: ['reload'], // 注入依赖
  data () {
    return {
      goodsDetail: [],
      address: {
        province: '省',
        city: '市',
        area: '区'
      },
      id: this.$route.query.id,
      sku: this.$route.query.sku,
      ImgUrl: '',
      qyloading: false,
      LeaveMessage: '',
      cont: '因：厂家繁杂、生产波动、地域差异。故：志鹏推荐、同类最佳、品质保障',
      config: {
        sites: ['wechat', 'qq', 'weibo', 'qzone'],
        wechatQrcodeTitle: '微信扫一扫：分享',
        wechatQrcodeHelper: '<p>扫一扫</p><p>二维码便可将本产品分享至朋友圈。</p>'
      },
      totalNumber: 0,
      totalAmount: 0,
      goodsNum: 0,
      distpickershow: false,
      hideArea: false,
      SameSpeci: [],
      checkedarr: [], // 所选中的复选框
      screensearch: '', // 筛选搜索内容
      loading: false,
      screendata: [], // 删选原始数据
      day: 0,
      hou: 0,
      min: 0,
      sec: 0,
      ssec: 0,
      endTime: '',
      showFlashsale: false,
      showinfo: 1,
      autoheight: {
        overflow: 'auto',
        minHeight: '350px',
        maxHeight: '536px'
      },
      sameparameter: [], // 同参数数据
      sameparameterdata: [] // 同参数数据
    }
  },
  watch: {
    $route (to, from) {
      this.reload()
    }
  },
  created () {
    this.getEndtime()
    this.time()
  },
  mounted () {
    if (this.id || this.sku) {
      this.getGoodsDetail(this.id, this.sku)
    } else {
      this.$route.push({path: '/'})
    }
    this.$nextTick(() => {
      this.getIpAddress()
    })
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  methods: {
    getGoodsDetail (id, sku) {
      this.loading = true
      this.qyloading = true
      var idOrSku = {}
      if (id) {
        idOrSku = {
          id: id
        }
      } else {
        idOrSku = {
          sku: sku
        }
      }
      api.getGoodsDetail(idOrSku).then(res => {
        let specdataInfo = []
        this.goodsDetail = res.items
        this.goodsDetail.imgpath = res.items.imgpath.split(',')
        this.ImgUrl = this.goodsDetail.imgpath[0]
        if (this.goodsDetail.correlation) {
          this.goodsDetail.correlation.map(res => {
            if (res.specParamList && res.specParamList !== 'null') {
              res.specParamList = JSON.parse(res.specParamList)
              specdataInfo.push(res.specParamList)
              this.screendata.push(res)
            }
          })
        }
        // 同参数型号
        this.goodsDetail.specParamList.map(res => {
          this.sameparameter.push(res.option_value)
        })
        for (var i = 0; i < this.goodsDetail.correlation.length; i++) {
          this.goodsDetail.correlation[i]['sameparameter'] = []
          if (this.goodsDetail.correlation[i]['specParamList'] && this.goodsDetail.correlation[i]['specParamList'] !== 'null') {
            for (var j = 0; j < this.goodsDetail.correlation[i]['specParamList'].length; j++) {
              this.goodsDetail.correlation[i]['sameparameter'].push(this.goodsDetail.correlation[i]['specParamList'][j]['option_value'])
            }
          }
          if (this.sameparameter.length === this.goodsDetail.correlation[i]['sameparameter'].length && this.sameparameter.sort().toString() === this.goodsDetail.correlation[i]['sameparameter'].sort().toString()) {
            this.sameparameterdata.push(this.goodsDetail.correlation[i])
          }
        }
        console.log(specdataInfo)
        // 转化格式合并
        this.formatmerge(specdataInfo)
        this.qyloading = false
        this.loading = false
      }).catch(res => {
        this.qyloading = false
        this.loading = false
      })
    },
    addCart (id) {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      if (this.LeaveMessage && !this.$refs['leavemsg'].valid()) {
        return
      }
      api.addCart({
        'id': id,
        'leaveMessage': this.LeaveMessage,
        'number': this.goodsDetail.number
      }).then(response => {
        this.$notify({
          title: '加入购物车',
          message: '添加成功',
          type: 'success'
        })
      })
    },
    buyItNow (goodsId) {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      if (this.LeaveMessage && !this.$refs['leavemsg'].valid()) {
        return
      }
      if (!this.goodsDetail.number) {
        this.$message.error('请确认采购数量')
        return
      }
      const BuyGoods = {
        'id': goodsId,
        'number': this.goodsDetail.number,
        'leaveMessage': this.LeaveMessage
      }
      localStorage.setItem('nowBuy_goods', JSON.stringify(BuyGoods))
      // 因为用ConfirmOrder页面，所以与跳转前清除申购单与购物车的store值
      localStorage.removeItem('cart_checkList')
      localStorage.removeItem('preorderList')
      localStorage.removeItem('fastList')
      this.$router.push({path: '/ConfirmOrder'})
    },
    calculate (cor) {
      var subCartList = []
      var number = 0
      var amount = 0
      this.goodsDetail.correlation.map((res, index) => {
        if (res.number) {
          var cartList = {
            goods_id: res.id,
            number: res.number
          }
          number += res.number
          amount += (res.number * res.tax_price)
          subCartList.push(cartList)
        }
      })
      this.goodsNum = subCartList.length
      this.totalNumber = number
      this.totalAmount = amount
    },
    batchAddCart () {
      if (!this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      var subCartList = []
      this.goodsDetail.correlation.map((res, index) => {
        if (res.number) {
          var cartList = {
            goods_id: res.id,
            number: res.number
          }
          // if (this.subCartList.findIndex((item) => { return item.goods_id === res.id }) === -1) {
          subCartList.push(cartList)
          // }
        // } else {
        //   this.subCartList.splice(index, 1)
        }
      })
      // console.log(subCartList)
      if (subCartList.length > 0) {
        api.batchAddCart(subCartList).then(res => {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
        })
      }
    },
    getIndex (index) {
      this.ImgUrl = this.goodsDetail.imgpath[index]
    },
    // 收藏
    delOrAddCollect (id) {
      if (!this.current_user || !this.current_user.id) {
        this.$message.error('请先登录')
        return
      }
      api.delOrAddCollect({'member_id': this.current_user.id, 'goods_id': id}).then(res => {
        this.goodsDetail.isCollect = this.goodsDetail.isCollect === 1 ? 0 : 1
      })
    },
    onChangeProvince (data) {
      this.address.province = data.value
    },
    onChangeCity (data) {
      this.address.city = data.value
    },
    onChangeArea (data) {
      this.address.area = data.value
    },
    getIpAddress () {
      api.getIpAddress().then(res => {
        if (res && res.code === 20000) {
          this.address.province = this.getCodeValue(parseInt(res.items.data.region_id)) ? this.getCodeValue(parseInt(res.items.data.region_id)) : '省'
          this.address.city = this.getCodeValue(parseInt(res.items.data.city_id)) ? this.getCodeValue(parseInt(res.items.data.city_id)) : '市'
          this.address.area = this.getCodeValue(parseInt(res.items.data.area_id)) ? this.getCodeValue(parseInt(res.items.data.area_id)) : '区'
        } else {
          this.address.province = '省'
          this.address.city = '市'
          this.address.area = '区'
        }
      })
    },
    getCodeValue (code) {
      for (let x in DISTRICTS) {
        for (let y in DISTRICTS[x]) {
          if (code === parseInt(y)) {
            return DISTRICTS[x][y]
          }
        }
      }
    },
    mouseOver () {
      this.distpickershow = true
    },
    mouseLeave () {
      this.distpickershow = false
    },
    formatmerge (resData) {
      let dataInfo = []
      for (var i = 0; i < resData.length; i++) {
        for (var j = 0; j < resData[i].length; j++) {
          dataInfo.push(resData[i][j])
        }
      }
      this.arraymerge(dataInfo)
    },
    arraymerge (resData) {
      let dataInfo = {}
      resData.forEach((item, index) => {
        // eslint-disable-next-line camelcase
        let { param_name } = item
        if (!dataInfo[param_name]) {
          dataInfo[param_name] = {
            param_name,
            child: [],
            open: true,
            childopen: ''
          }
        }
        dataInfo[param_name].child.push(item)
      })
      this.SameSpeci = Object.values(dataInfo) // list 转换成功的数据
      for (var i = 0; i < this.SameSpeci.length; i++) {
        this.SameSpeci[i].child = this.removeDuplicateObj(this.SameSpeci[i].child)
        if (this.SameSpeci[i].child.length > 6) {
          this.SameSpeci[i].childopen = true
        }
      }
      // console.log(this.SameSpeci)
      // 获取高度
      this.changeHeight(500)
    },
    // 去重
    removeDuplicateObj (arr) {
      var newarr = []
      var obj = {}
      for (var i = 0; i < arr.length; i++) {
        this.$set(arr[i], 'checked', false) // 这里，给对象添加属性，用$set方法。
        if (!obj[arr[i].option_value]) {
          newarr.push(arr[i])
          obj[arr[i].option_value] = true // 用来判断此对象已加入新数组
        }
      }
      return newarr
    },
    // 复选框改变的方法
    checkedFn (item) {
      // console.log(item, 'item')
      // 每次选中前都清空
      this.loading = true
      this.checkedarr = []
      this.goodsDetail.correlation = []
      for (var i = 0; i < this.SameSpeci.length; i++) {
        for (var j = 0; j < this.SameSpeci[i]['child'].length; j++) {
          if (this.SameSpeci[i]['child'][j].checked) {
            this.checkedarr.push(this.SameSpeci[i]['child'][j])
          }
        }
      }
      for (var x = 0; x < this.screendata.length; x++) {
        for (var y = 0; y < this.screendata[x]['specParamList'].length; y++) {
          for (var z = 0; z < this.checkedarr.length; z++) {
            if (this.checkedarr[z]['param_name'] === this.screendata[x]['specParamList'][y]['param_name'] && this.checkedarr[z]['option_value'] === this.screendata[x]['specParamList'][y]['option_value']) {
              this.goodsDetail.correlation.push(this.screendata[x])
            }
          }
          // console.log(this.screendata[x]['specParamList'][y])
          // console.log(this.checkedarr)
        }
      }
      if (this.goodsDetail.correlation.length === 0) {
        this.goodsDetail.correlation = this.screendata
      }
      this.loading = false
    },
    screensearchs () {
      if (this.screensearch === '') {
        this.$message({
          message: '请输入产品名称 订货号',
          type: 'warning'
        })
      } else {
        this.screenCorrelation()
      }
    },
    // 筛选查询
    screenCorrelation () {
      this.loading = true
      var params = {}
      if (this.id) {
        params = {
          id: this.id,
          screensearch: this.screensearch
        }
      } else {
        params = {
          sku: this.sku,
          screensearch: this.screensearch
        }
      }
      api.screenCorrelation(params).then(res => {
        if (res.code === 20000) {
          this.goodsDetail.correlation = []
          this.goodsDetail.correlation = res.items
        } else if (res.code === 50000) {
          this.goodsDetail.correlation = []
        }
        this.loading = false
      })
    },
    clearcheckbox () {
      for (var i = 0; i < this.SameSpeci.length; i++) {
        for (var j = 0; j < this.SameSpeci[i]['child'].length; j++) {
          this.SameSpeci[i]['child'][j].checked = false
        }
      }
      this.goodsDetail.correlation = this.screendata
    },
    changeopen (item) {
      if (item.open) {
        item.open = false
      } else {
        item.open = true
      }
      // console.log(item)
      // 更改高度
      this.changeHeight(0)
    },
    changeopenmore (item, index) {
      if (item.childopen) {
        item.childopen = false
      } else {
        item.childopen = true
        // 内容回到最顶部
        document.getElementById('gotop' + index).scrollTop = 0
      }
      // console.log(item)
      // 更改高度
      this.changeHeight(0)
    },
    getEndtime () {
      flashsale.getEndTime({ 'id': 1 }).then(res => {
        this.endTime = res.items.endtime
      })
    },
    time () {
      var that = this
      setInterval(function timestampToTime () {
        var date = (new Date(that.endTime)) - (new Date())
        // new Date当前的时间戳，也可以换成自定义的时间戳
        if (date > 0) {
          let time = date / 1000
          // 获取时、分、秒,毫秒
          that.day = parseInt(time / (24 * 3600)) < 10 ? ('0' + parseInt(time / (24 * 3600))) : parseInt(time / (24 * 3600))
          that.hou = parseInt((time % (60 * 60 * 24)) / 3600) < 10 ? ('0' + parseInt((time % (60 * 60 * 24)) / 3600)) : parseInt((time % (60 * 60 * 24)) / 3600)
          that.min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) / 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) / 60)
          that.sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) % 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) % 60)
          that.ssec = parseInt(((date % (60 * 60 * 24)) % 3600) / 60) % 10
          that.showFlashsale = true
        } else {
          // 活动已结束，全部设置为'00'
          that.showFlashsale = false
          that.day = '00'
          that.hou = '00'
          that.min = '00'
          that.sec = '00'
        }
      }, 100)
    },
    showproductinfo (e) {
      this.showinfo = e
    },
    changeHeight (time) {
      setTimeout(() => {
        const autoheights = document.querySelector('.goods-select-side').clientHeight
        this.autoheight = {
          overflow: 'auto',
          height: (autoheights - 40) + 'px'
        }
      }, time)
    }
  }
}
</script>
<style scoped>
  .kuazp_cont{
    font-size: 12px;
    line-height: 15px;
    color: #000000;
    font-family: MicrosoftYaHeiUI;
    letter-spacing:1px;
    margin: 10px 0 0 0;
    text-indent: 0.7cm;
    max-height: 195px;
    min-height: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 13;
    -webkit-box-orient: vertical;
  }
  .service_value{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .service_value .img_label{
    display: flex;
    margin-left: 10px;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
  }
  .service_value .img_label .icon_value{
    width: 16px;
    height: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #ff7324;
    border-radius: 3px;
    border: 1px solid #ff7324;
  }
  .service_value .img_label .text_value{
    font-size: 12px;
    margin-left: 5px;
    color: #222;
  }
  .kfdh{
    font-size: 12px;
  }
  .kfdh span:first-child i {
    color: #ff7324;
    border: 1px solid #ff7324;
    border-radius: 3px;
    padding: 2px;
  }
  .kfdh span a{
    color: #ff7324;
    border: 1px solid #ff7324;
    border-radius: 3px;
    padding: 2px;
  }
  h1, h2, h3, strong{
    font-weight: 600;
  }
  .mySpecParam{
    width: 100%;
    line-height: 20px;
    display: inline-block;
    margin-top: 10px;
  }
  .hxq_spxx1_rt_btn{
    padding: 20px 20px 10px 0px;
  }
  .mySpecParam > div > em {
    float: left;
    font-size: 12px;
    color: #919191;
    text-align: left;
  }
  .mySpecParam > div > div {
    font-size: 12px;
  }
  .mySpecParam > div > div {
    float: left;
    padding-right: 10px;
  }
  .hg {
    overflow-x: auto !important;
    height: 400px;
  }

  .sg {
    overflow-y: auto !important;
  }
  .kuazp_tit {
    margin-top: 20px;
    text-align: center;
    font-size: 18px;
    line-height: 35px;
    color: #333;
    font-weight: bold;
  }
  .kuazp_con {
    padding: 10px 0 20px;
    margin-top: 15px;
    border:1px solid #e2e2e2;
    border-radius: 2px;
  }
  .kuazp_con li {
    margin-top: 10px;
    padding-left: 10px
  }
  .kuazp_con li img {
    margin-right: 7px;
  }
  .kuazp_con li em {
    color: #666;
  }
  table{
    margin:0 auto;
  }
  .newtitles{
    font-size: 14px;
    color: #333;
    line-height: 24px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    white-space: break-spaces !important;
  }
  .pic-box{
    width: 400px;
    height: 400px;
  }
  .el-input-number--medium{
    width: 150px !important;
    margin-right: 5px;
  }
  .hxq_delivery{
    border: 1px solid #CECBCE;
    padding: 0 4px 0 4px;
    display: inline-block;
    height: 26px;
    line-height: 26px;
    margin-top: 3px;
  }
  .hxq_distpicker{
    background-color: #fff;
    position: absolute;
    z-index: 99999999;
    margin-top: 29px;
  }
  /* 新增产品选项 */
  .other-goods-wrap {
    margin-top: 10px;
    /* border: 1px solid #ededed; */
  }
  .other-goods-wrap .tabs-box {
    border: 1px solid #e2e2e2;
    height: 40px;
    background-color: #f7f7f7;
  }
  .other-goods-wrap .tabs-box span {
    float: left;
    line-height: 40px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    min-width: 100px;
    max-width: 180px;
    overflow: hidden;
    white-space: nowrap;
    word-break: break-all;
    text-overflow: ellipsis;
    padding: 0 20px;
    cursor: pointer;
    color: #606266;
    border: none;
    border: 1px solid #e2e2e2;
    margin-top: -1px;
    background-color: #fff;
  }
  .other-goods-wrap .tabs-box .select_tab {
    float: left;
    line-height: 40px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    min-width: 100px;
    max-width: 180px;
    overflow: hidden;
    white-space: nowrap;
    word-break: break-all;
    text-overflow: ellipsis;
    padding: 0 20px;
    cursor: pointer;
    color: #ff7300;
    border: none;
    border-top: 2px solid #ff7300;
    margin-top: -1px;
    background-color: #fff;
  }
  .other-goods-wrap .goods-select-box {
    position: relative;
    border: 1px solid #e2e2e2;
    margin-top: -1px;
  }
  .other-goods-wrap .goods-select-side {
    /* margin-top: 20px; */
    position: absolute;
    width: 252px;
    margin-left: -1px;
  }
  .side-select-wrap {
    float: left;
    width: 215px;
  }
  .side-select-wrap .left-header {
    height: 20px;
    line-height: 20px;
    padding: 10px;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    background-color: #5178b5;
    text-align: left;
  }
  .side-select-wrap .left-header em {
    display: inline-block;
    border: 1px solid #fff;
    width: 16px;
    height: 16px;
    line-height: 8px;
    text-align: center;
    font-weight: 900;
    margin-right: 10px;
    vertical-align: middle;
  }
  .side-select-wrap .left-header .reset-btn {
    font-size: 12px;
    height: 20px;
    border: 1px solid #fff;
    color: #fff;
    padding: 0 6px;
    float: right;
    margin-right: 10px;
    border-radius: 4px;
    cursor: pointer;
  }
  .side-select-wrap .attr-item {
    border: 1px solid #e2e2e2;
    border-bottom: none;
    padding: 0;
  }
  .side-select-wrap .attr-item .item-header {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    background: #f7f7f7;
    color: #666;
    font-size: 12px;
    font-weight: 700;
    text-align: left;
  }
  .side-select-wrap .attr-item .item-header i.up-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-filter: FlipV;
    filter: FlipV;
  }
  .side-select-wrap .attr-item .item-header i {
    float: right;
    margin-top: 5px;
    margin-right: 5px;
    width: 20px;
    height: 20px;
    background: url(../../assets/images/xjt.png) center 50% no-repeat;
    cursor: pointer;
  }
  .side-select-wrap .attr-item .attr-option-container {
    border: 1px solid #fff;
    padding: 20px 0 5px 10px;
    /* max-height: 272px; */
    overflow: auto;
  }
  .checkbox-grop-wrap {
    font-size: 12px;
  }
  .side-select-wrap .attr-item.attr-item-iw .checkbox-grop-wrap li {
    width: 100%;
  }
  .side-select-wrap .attr-item .attr-option-container .checkbox-grop-wrap li {
    text-align: left;
    margin-bottom: 15px;
  }
  .checkbox-grop-wrap li {
    float: left;
  }
  .side-select-wrap .attr-item .attr-option-container .checkbox-grop-wrap li .checkbox-wrap {
    padding-left: 18px;
    white-space: break-spaces;
    max-width: 168px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .other-goods-wrap .checkbox-wrap {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .checkbox-wrap {
    white-space: nowrap;
    cursor: pointer;
    outline: none;
    display: inline-block;
    position: relative;
    line-height: 1;
    line-height: 20px;
    margin: 0 5px;
  }
  .checkbox-wrap, .pagination .vertical-middle {
    vertical-align: middle;
  }
  .checkbox-wrap input[type=checkbox] {
    box-sizing: border-box;
    padding: 0;
  }
  .checkbox-wrap .checkbox-input {
    position: absolute;
    left: 0;
    z-index: 9999;
    cursor: pointer;
    opacity: 0;
    top: 2px;
    margin-right: 4px;
    bottom: 0;
    right: 0;
    line-height: normal;
  }
  .side-select-wrap .attr-item .attr-option-container .checkbox-grop-wrap li .checkbox-wrap .checkbox-inner {
    position: absolute;
    top: 3px;
  }
  .other-goods-wrap .goods-select-list {
    float: right;
    width: 930px;
    /* margin-top: 20px; */
    margin-right: -1px;
  }
  .other-goods-wrap .goods-select-list .search-box {
    height: 38px;
    line-height: 38px;
    text-align: left;
  }
  .other-goods-wrap .goods-select-list .search-box label {
    position: relative;
  }
  .other-goods-wrap .goods-select-list .search-box .bg-search-icon {
    position: absolute;
    top: 1px;
    left: 10px;
  }
  .bg-search-icon {
    width: 17px;
    height: 17px;
    padding-left: 0!important;
    font-size: 13px!important;
    color: #cfcfcf;
    cursor: default;
  }
  .other-goods-wrap .goods-select-list .search-box input {
    width: 230px;
    height: 38px;
    background: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 2px;
    line-height: 36px;
    padding: 0 25px 0 35px;
  }
  .other-goods-wrap .goods-select-list .search-box button {
    width: 60px;
    height: 38px;
    background: #5178b5;
    border-radius: 2px;
    margin-left: 10px;
    border: none;
    color: #fff;
    cursor: pointer;
  }
  .list-detail-wrap {
    width: 929px;
    position: relative;
    /* margin-top: 20px; */
  }
  .list-detail-wrap .list-item-header {
    /* background: #f7f7f7; */
    width: 928px;
    border: 1px solid #e2e2e2;
    height: 38px;
    line-height: 38px;
  }
  .list-detail-wrap .tw1 {
    width: 365px;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wrap .tw2 {
    width: 105px;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wrap .tw3 {
    width: 70px;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wrap .tw4 {
    width: 100px;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wrap .tw5 {
    width: 133px;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wrap .tw6 {
    width: 134px;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wrap .goods-list {
    width: 100%;
    box-sizing: border-box;
    height: 100px;
    position: relative;
    border: 1px solid #e2e2e2;
    border-top: none;
    transition: border-color .1s ease;
    overflow: hidden;
  }
  .list-detail-wrap .goods-list .goods-info {
    position: relative;
    text-align: center;
  }
  .list-detail-wrap .goods-list>div {
    box-sizing: border-box;
  }
  .list-detail-wrap .goods-list .goods-info .img-wrap {
    float: left;
    margin: 14px 10px 14px 20px;
  }
  .list-detail-wrap .goods-list .goods-info img {
    width: 70px;
    height: 70px;
    border: 1px solid #e2e2e2;
  }
  .list-detail-wrap .goods-list .goods-info .goods-name {
    float: left;
    width: 250px;
    margin-top: 15px;
  }
  .list-detail-wrap .goods-list .goods-info .goods-tagcont {
    margin-bottom: 6px;
  }
  .list-detail-wrap .goods-list .goods-info .name {
    width: 250px;
    text-align: left;
    line-height: 18px;
    color: #333;
    text-overflow: ellipsis;
    margin-bottom: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
  }
  .list-detail-wrap .goods-list .goods-info .sku-number {
    color: #999;
    text-align: left;
  }
  .list-detail-wrap .goods-list .goods-info .sku-number span {
    display: inline-block;
    line-height: 20px;
    vertical-align: middle;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 250px;
  }
  .list-detail-wrap .goods-list .deliver-leadTime {
    margin: 45px 0 0;
    position: relative;
    z-index: 2;
    height: auto;
  }
  .list-detail-wrap .goods-list .deliver-leadTime .h48 {
    background-color: #ff8e50;
    border: 1px solid #ff8e50;
    color: #fff;
    padding: 0 0px;
    border-radius: 5px;
  }
  .other-goods-wrap .deliver.h48 {
    background-color: #ff8e50;
    color: #fff;
    padding: 2px 7px;
    border-radius: 3px;
  }
  .list-detail-wrap .goods-list .real-unit {
    margin: 40px 0;
    line-height: 20px;
    height: auto;
  }
  .list-detail-wrap .goods-list .goods-price span {
    display: inline-block;
    color: #f74747;
    font-family: Verdana;
    margin-top: 45px;
  }
  .list-detail-wrap .goods-list .goods-price {
    line-height: 10px;
    vertical-align: middle;
  }
  .list-detail-wrap .goods-list .add-shop-cart {
    display: inline-block;
    margin: 35px 0;
  }
  .list-detail-wrap .goods-list .add-shop-cart .add-cart-left-none {
    color: #999;
  }
  .list-detail-wrap .goods-list .add-shop-cart .add-cart-left {
    float: left;
    overflow: hidden;
    width: 24px;
    height: 24px;
    border: 1px solid #e6e1db;
    text-align: center;
    line-height: 22px;
    font-size: 24px;
    cursor: pointer;
    background: #f1f1f1;
    color: #666;
  }
  .add-shop-cart input {
    float: left;
    padding: 0 3px;
    width: 40px;
    height: 24px;
    border: 1px solid #e6e1db;
    border-right: none;
    border-left: none;
    text-align: center;
    line-height: 20px;
  }
  .list-detail-wrap .goods-list .add-shop-cart .add-cart-right {
    float: left;
    overflow: hidden;
    width: 24px;
    height: 24px;
    border: 1px solid #e6e1db;
    text-align: center;
    line-height: 22px;
    font-size: 18px;
    cursor: pointer;
    background: #f1f1f1;
  }
  .add-shop-cart .add-cart-right {
    float: left;
    overflow: hidden;
    width: 24px;
    height: 24px;
    border: 1px solid #e6e1db;
    text-align: center;
    line-height: 22px;
    font-size: 18px;
    cursor: pointer;
    background: #f1f1f1;
  }
  .list-detail-wrap .goods-list .btn-wrap .add-cart-btn {
    width: 90px;
    height: 28px;
    background: #5178b5;
    border-radius: 2px;
    color: #fff;
    cursor: pointer;
    margin-bottom: 10px;
  }
  .list-detail-wrap .goods-list .btn-wrap button {
    padding: 0;
    border: none;
    font-size: 12px;
  }
  .list-detail-wrap .goods-list .btn-wrap .add-cart-btn .icon-add-cart {
    font-size: 12px;
    margin-right: 3px;
  }
  .iconfont {
    font-family: iconfont!important;
    padding-left: 4px;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
  }
  .list-detail-wrap .goods-list .btn-wrap .compare-btn {
    width: 42px;
    height: 20px;
    background: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 3px;
    color: #666;
    font-size: 12px;
    cursor: pointer;
  }
  .list-detail-wrap .goods-list .btn-wrap button {
    padding: 0;
    border: none;
    font-size: 12px;
  }
  .list-detail-wrap .goods-list .btn-wrap {
    text-align: center;
    margin-top: 35px;
    font-size: 12px;
    height: auto;
  }
  .side-select-wrap .attr-item:last-child {
    border-bottom: 1px solid #e2e2e2;
  }
  .side-select-wrap .attr-item .attr-option-container.max-container {
    /* max-height: 100px; */
    overflow: hidden;
  }
  .side-select-wrap .more_option {
    text-align: center;
    padding: 0 0 10px;
    cursor: pointer;
    line-height: 18px;
    color: #606266;
  }
  .side-select-wrap .more_option i {
    margin-left: 5px;
    width: 14px;
    height: 9px;
    display: inline-block;
    background: url(../../assets/images/xjt.png) center 50% no-repeat;
  }
  .side-select-wrap .more_option i.up-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-filter: FlipV;
    filter: FlipV;
  }
  .list-item-side{
    overflow: auto;
    height: 649px;
  }
  .cght_cnxhtiwtjsp{ height:167px; width:100%; padding-top:175px;}
  .cght_cnxhtiwtjsp div{ width:200px; text-align:center; padding-left:100px; background:url(../../assets/images/spsc_img02.png) no-repeat left center; height:60px; line-height:60px;font-size:18px; color:#959595; margin:0px auto; clear:both;}
  .myemptydata {color:#959595}
  /* 新增产品选项 */
  .kuazp .other {
    width: 100%;
    height: 195px;
    /* margin-top: 20px;
    padding-top: 10px; */
    /* border-top: 1px solid #f0f0f0;
    border-left: 1px solid #f0f0f0; */
  }
  .kuazp_image{
    padding: 0;
    border-radius: 6px;
    margin: 10px 0 0 0;
  }
  .kuazp .other .title {
    width: 100%;
    height: 17px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #9B9B9B;
    line-height: 16px;
    letter-spacing: 1px;
    margin: 15px 0 8px 9px;
  }
  .kuazp .other .service-des {
    font-size: 12px;
    font-family: MicrosoftYaHeiUI;
    color: #000000;
    line-height: 15px;
    letter-spacing: 1px;
    margin-left: 9px;
  }
  .kuazp .other .sale-before-des {
    font-size: 12px;
    font-family: MicrosoftYaHeiUI;
    color: #000000;
    line-height: 15px;
    letter-spacing: 1px;
    margin-left: 9px;
  }
  .kuazp .other .el-icon-phone-outline {
    font-size: 15px;
  }
  .kuazp .other a {
    color: #000000;
  }
  .kuazp .other .el-icon-service {
    font-size: 15px;
  }
  .list-detail-wraps {
    position: relative;
    /* margin-top: 20px; */
  }
  .list-detail-wraps .list-item-header {
    /* background: #f7f7f7; */
    border: 1px solid #e2e2e2;
    height: 38px;
    line-height: 38px;
  }
  .list-detail-wraps .tw1 {
    width: 32%;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wraps .tw2 {
    width: 10%;
    float: left;
    text-align: left;
    height: 100%;
  }
  .list-detail-wraps .tw3 {
    width: 10%;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wraps .tw4 {
    width: 5%;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wraps .tw5 {
    width: 10%;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wraps .tw6 {
    width: 18%;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wraps .tw7 {
    width: 10%;
    float: left;
    text-align: center;
    height: 100%;
  }
  .list-detail-wraps .goods-list {
    width: 100%;
    box-sizing: border-box;
    height: 130px;
    position: relative;
    border: 1px solid #e2e2e2;
    border-top: none;
    transition: border-color .1s ease;
    overflow: hidden;
  }
  .list-detail-wraps .goods-list .goods-info {
    position: relative;
    text-align: center;
  }
  .list-detail-wraps .goods-list>div {
    box-sizing: border-box;
  }
  .list-detail-wraps .goods-list .goods-info .img-wrap {
    float: left;
    margin: 14px 10px 14px 20px;
  }
  .list-detail-wraps .goods-list .goods-info img {
    width: 80px;
    height: 80px;
    border: 1px solid #e2e2e2;
  }
  .list-detail-wraps .goods-list .goods-info .goods-name {
    float: left;
    width: 250px;
    margin-top: 15px;
  }
  .list-detail-wraps .goods-list .goods-info .goods-tagcont {
    margin-bottom: 6px;
  }
  .list-detail-wraps .goods-list .goods-info .name {
    width: 250px;
    text-align: left;
    line-height: 18px;
    color: #333;
    text-overflow: ellipsis;
    margin-bottom: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
  }
  .list-detail-wraps .goods-list .goods-info .sku-number {
    color: #999;
    text-align: left;
  }
  .list-detail-wraps .goods-list .goods-info .sku-number span {
    display: inline-block;
    line-height: 20px;
    vertical-align: middle;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 250px;
  }
  .list-detail-wraps .goods-list .goods-parameter .sku-number {
    display: inline-block;
    color: #999;
    text-align: left;
    margin-top: 5px;
    overflow-y: auto;
    height: 119px;
  }
  .list-detail-wraps .goods-list .goods-parameter .sku-number::-webkit-scrollbar {/*滚动条整体样式*/
    width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .list-detail-wraps .goods-list .goods-parameter .sku-number::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: #c1c1c1;
  }
  .list-detail-wraps .goods-list .goods-parameter .sku-number::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
  }
  .list-detail-wraps .goods-list .goods-parameter .sku-number span {
    display: inline-block;
    vertical-align: middle;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
  }
  .list-detail-wraps .goods-list .deliver-leadTime {
    margin: 55px 6px 0;
    line-height: 20px;
    position: relative;
    z-index: 2;
    height: auto;
  }
  .list-detail-wraps .goods-list .deliver-leadTime .h48 {
    background-color: #ff8e50;
    border: 1px solid #ff8e50;
    color: #fff;
    padding: 0 5px;
    border-radius: 5px;
  }
  .list-detail-wraps .goods-list .real-unit {
    margin: 55px 0;
    line-height: 20px;
    height: auto;
  }
  .list-detail-wraps .goods-list .goods-price span {
    display: inline-block;
    color: #f74747;
    font-family: Verdana;
    margin-top: 58px;
  }
  .list-detail-wraps .goods-list .goods-price {
    line-height: 18px;
    vertical-align: middle;
  }
  .list-detail-wraps .goods-list .add-shop-cart {
    display: inline-block;
    margin: 53px 0;
  }
  .list-detail-wraps .goods-list .add-shop-cart .add-cart-left-none {
    color: #999;
  }
  .list-detail-wraps .goods-list .add-shop-cart .add-cart-left {
    float: left;
    overflow: hidden;
    width: 24px;
    height: 24px;
    border: 1px solid #e6e1db;
    text-align: center;
    line-height: 22px;
    font-size: 24px;
    cursor: pointer;
    background: #f1f1f1;
    color: #666;
  }
  .list-detail-wraps .goods-list .add-shop-cart .add-cart-right {
    float: left;
    overflow: hidden;
    width: 24px;
    height: 24px;
    border: 1px solid #e6e1db;
    text-align: center;
    line-height: 22px;
    font-size: 18px;
    cursor: pointer;
    background: #f1f1f1;
  }
  .list-detail-wraps .goods-list .btn-wrap .add-cart-btn {
    width: 90px;
    height: 28px;
    background: #5178b5;
    border-radius: 2px;
    color: #fff;
    cursor: pointer;
    margin-bottom: 10px;
  }
  .list-detail-wraps .goods-list .btn-wrap button {
    padding: 0;
    border: none;
    font-size: 12px;
  }
  .list-detail-wraps .goods-list .btn-wrap .add-cart-btn .icon-add-cart {
    font-size: 12px;
    margin-right: 3px;
  }
  .list-detail-wraps .goods-list .btn-wrap .compare-btn {
    width: 42px;
    height: 20px;
    background: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 3px;
    color: #666;
    font-size: 12px;
    cursor: pointer;
  }
  .list-detail-wraps .goods-list .btn-wrap button {
    padding: 0;
    border: none;
    font-size: 12px;
  }
  .list-detail-wraps .goods-list .btn-wrap {
    text-align: center;
    margin-top: 54px;
    font-size: 12px;
    height: auto;
  }
  .checkbox-input >>>.el-checkbox__label {
    display: inline-grid;
    white-space: pre-line;
    word-wrap: break-word;
    overflow: hidden;
    line-height: 20px;
    font-size: 12px;
    max-width: 210px;
  }
</style>
<style>
  .mouse-cover-canvas{
    position: absolute;
    width: 405px !important;
    left: 770px !important;
    top: 285px !important;
    border: 1px solid rgb(238, 238, 238);
    z-index: 99999;
    display: none;
  }
  .address-headers {
    padding-top: 6px!important;
  }
  .distpicker-address-wrapper .address-headers ul {
    margin-left: 60px!important;
    display: block!important;
  }
  .distpicker-address-wrapper .address-headers ul li {
    color: #07357b!important;
    display: inline-block!important;
    padding: 0px 20px 0px 10px!important;
    font-size: 13px!important;
    line-height: 20px!important;
    border: 1px solid #CECBCE!important;
    border-bottom: 0!important;
    background: url(../../assets/images/jaintou_01.png) no-repeat 90% center!important;
    background-size: 0.8em!important;
    cursor: pointer!important;
  }
  .distpicker-address-wrapper .address-headers ul li.active {
    border: 2px solid #07357b!important;
    color: #07357b!important;
    border-bottom: #fff solid 2px!important;
  }
  .address-container {
    border-top: #07357b solid 2px!important;
    box-shadow: 0 1.5px 1px 1px #ddd!important;
    display: block!important;
    margin-top: -5px!important;
  }
  .distpicker-address-wrapper .address-container ul {
    width: 498px!important;
    border: 1px solid #fff!important;
    padding-bottom: 6px!important;
  }
  .distpicker-address-wrapper .address-container ul li {
    color: #666!important;
    padding: 3px 0px 0px 15px!important;
    float: left!important;
    border-top: 0px solid #f6f6f6!important;
    cursor: pointer!important;
    font-size: 13px!important;
    width: 109px;
    clear: none;
    line-height: 18px;
    text-align: left;
    margin: 3px 0px 3px 0px;
  }
  .distpicker-address-wrapper .address-container ul li:hover {
    color: #07357b!important;
  }
  .distpicker-address-wrapper:hover .address-container {
    display: block!important;
  }
  .distpicker-address-wrapper .address-container ul li.active {
    color: #07357b!important;
  }
  .hxq_spxx1_rt_jg_sk {
    background: url(../../assets/images/xsmsbj.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 -20px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .activity-timedown {
    box-sizing: border-box;
    height: 60px;
    line-height: 60px;
    padding: 0 18px;
    font-size: 16px;
    color: #fff;
  }
  .m-timedown .item, .m-timedown {
    display: inline-block;
    height: 24px;
    line-height: 24px;
  }
  .m-timedown {
    text-align: center;
    margin-left: 10px;
  }
  .m-timedown .item .n.s {
    background: none;
    padding-right: 0;
  }
  .m-timedown .item .n {
    position: relative;
    display: inline-block;
    min-width: auto;
    height: 24px;
    line-height: 24px;
    padding: 0 6px;
    border-radius: 2px;
    background: #000;
    font-size: 16px;
    font-style: normal;
    color: #fff;
    vertical-align: middle;
  }
  .ljgm {
    width: 90px !important;
    height: 40px !important;
    line-height: 40px !important;
    font-size: 15px !important;
    font-weight: bold;
  }
  .join_cart {
    width: 90px !important;
    height: 40px !important;
    line-height: 40px !important;
    font-size: 15px !important;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/view/goods/goodsDetail.vue